const axios = require('axios').default;

export function saveBitrixOptions(options) {
  return new Promise((resolve, reject) => {
    axios.put('/app/bitrix', options).then(() => resolve()).catch(() => reject());
  });
}